module.exports = __webpack_public_path__ + "img/icon-exper-3.0bf9ec03.png";